import dayjs from 'dayjs';
import api from '../../api';
import consts from '../../helpers/consts';

function mapperDeviceData(deviceData) {
  let startPeriodFormated = ''
  let endPeriodFormated = ''
  if (deviceData.expirationDate) {
    startPeriodFormated = dayjs(deviceData.startPeriod).format('YYYY-MM-DD');
    endPeriodFormated = dayjs(deviceData.endPeriod).format('YYYY-MM-DD');
  }

  let default_computer = deviceData.default_computer ? '1' : '0';
  let active = deviceData.active ? '1' : '0';

  if (deviceData.deviceType === 'my_ahgora_device') {
    default_computer = '1'
    active = '1'
  }

  return {
    active: active,
    name: deviceData.name,
    timezone: deviceData.timezone,
    device_type: deviceData.deviceType,
    startPeriod: startPeriodFormated,
    endPeriod: endPeriodFormated,
    activationKey: deviceData.activationKey.toString() || '',
    enable_password_punch: deviceData.enable_password_punch ? '1' : '0',
    // save_photo_on_punch	?
    is_repa: deviceData.is_repa ? '1' : '0',
    timezone_filter: deviceData.timezone_filter ? '1' : '0',
    break_device: deviceData.break_device ? '1' : '0',
    enable_auto_update: deviceData.enable_auto_update ? '1' : '0',
    default_computer: default_computer,
    triple_validation: deviceData.triple_validation ? 'on' : 'off',
    enable_punches_logs: deviceData.enable_punches_logs ? '1' : '0',
    enable_punch_backup: deviceData.enable_punch_backup ? '1' : '0',
    enable_punch_by_manager: deviceData.enable_punch_by_manager ? '1' : '0',
    save_photo_on_punch: deviceData.save_photo_on_punch ? '1' : '0',
    enable_facial_recognition_flow: deviceData.enable_facial_recognition_flow ? '1' : '0',
    online_only: deviceData.online_only ? '1' : '0',
    auto_timezone: deviceData.auto_timezone ? '1' : '0',
    only_with_location: deviceData.only_with_location ? '1' : '0',
    only_inside_geofence: deviceData.only_inside_geofence ? '1' : '0',
    range_ip: deviceData.ips.join(','),
    blink: deviceData.blink ? '1' : '0',
    smile: deviceData.smile ? '1' : '0',
    head_movement: deviceData.head_movement ? '1' : '0',
    hide_password_config_access: deviceData.hide_password_config_access ? '1' : '0',
    hide_reconfigure_multi: deviceData.hide_reconfigure_multi ? '1' : '0',
    hide_punch_receipt_display_time: deviceData.hide_punch_receipt_display_time ? '1' : '0',

    optionEmployeesFilter: deviceData.collaboratorsType === 'by_employee' ? '1' : '0',
    useSelectAllEmployees: deviceData.useSelectAllEmployees ? '1' : '0',

    cnpj: deviceData.cnpj,
    employees: deviceData.employees,
    locations: deviceData.locations,
  }
}


function mapperMultipleDeviceData(deviceData) {
  let startPeriodFormated = '';
  let endPeriodFormated = '';

  if (deviceData.expirationDate) {
    startPeriodFormated = dayjs(deviceData.startPeriod).format('YYYY-MM-DD');
    endPeriodFormated = dayjs(deviceData.endPeriod).format('YYYY-MM-DD');
  }

  return {
    name: deviceData.name,
    timezone_device: deviceData.timezone,
    device_type: deviceData.deviceType,
    startPeriod: startPeriodFormated,
    endPeriod: endPeriodFormated,
    cnpj: deviceData.cnpj,
    company: deviceData.company,
    activationKey: deviceData.activationKey.toString() || '',
    enable_password_punch: deviceData.enable_password_punch ? '1' : '0',
    timezone_filter: deviceData.timezone_filter ? '1' : '0',
    enable_auto_update: deviceData.enable_auto_update ? '1' : '0',
    triple_validation: deviceData.triple_validation ? 'on' : 'off',
    enable_punches_logs: deviceData.enable_punches_logs ? '1' : '0',
    enable_punch_backup: deviceData.punches_backup?.enable_punch_backup ? '1' : '0',
    enable_punch_by_manager: deviceData.enable_punch_by_manager ? '1' : '0',
    save_photo_on_punch: deviceData.save_photo_on_punch ? '1' : '0',
    enable_facial_recognition_flow: deviceData.enable_facial_recognition_flow ? '1' : '0',
    online_only: deviceData.online_only ? '1' : '0',
    auto_timezone: deviceData.auto_timezone ? '1' : '0',
    only_with_location: deviceData.only_with_location ? '1' : '0',
    only_inside_geofence: deviceData.only_inside_geofence ? '1' : '0',
    range_ip: deviceData.ips.join(','),
    blink: deviceData.blink ? '1' : '0',
    smile: deviceData.smile ? '1' : '0',
    head_movement: deviceData.head_movement ? '1' : '0',
  };
}


export const createDevice = async ({deviceData, queryClient}) => {
  const payload = mapperDeviceData(deviceData);

  try {
    const response = await api.post(`${consts.BASE_PATH_API}batidaonline/setRegistration`, payload);

    if (!response) {
      throw new Error('Não foi possível criar o dispositivo');
    }

    // Ensure we have the required data
    if (!response.identity) {
      console.error('No identity in create response:', response);
      throw new Error(response.errorType);
    }

    // Check for activation key in different possible response formats
    const activationKey = response.hash;
    let deviceType = deviceData.deviceType;

    // Check if deviceType is 'ahgora_online_device' and default_computer is true
    if (deviceData.deviceType === 'ahgora_online_device' && deviceData.default_computer) {
      deviceType = 'ahgora_online_device_default'
    }

    queryClient.invalidateQueries(['devices']);

    return {
      response: {
        deviceType: deviceType,
        identity: response.identity,
        activationKey: activationKey,
        company: response.company
      }
    };

  } catch (error) {
    console.error('Error in createDevice:', error);
    throw new Error(error);
  }
}

export const createMultipleDevices = async ({deviceData, queryClient}) => {
  const payload = mapperMultipleDeviceData(deviceData);
  try {
    const response = await api.post(`${consts.BASE_PATH_API}batidaonline/generateMultiActivationCodes`, payload);
    if (!response) {
      throw new Error('Não foi possível criar multiplos dispositivos');
    }

    queryClient.invalidateQueries(['devices']);

    return {
      ...response
    };
  } catch (error) {
    throw new Error(`Erro ao criar multiplos dispositivos: ${error.message}`);
  }
}

export const editDevice = async ({ identity, deviceData, queryClient }) => {
  const payload = mapperDeviceData(deviceData);
  try {
    const response = await api.post(`${consts.BASE_PATH_API}batidaonline/setRegistration`, { ...payload, identity });
    if (!response) {
      throw new Error('Não foi possível criar o dispositivo');
    }

    queryClient.invalidateQueries(['devices']);
    return {
      response
    };
  } catch (error) {
    throw new Error(`Erro ao criar dispositivos: ${error.message}`);
  }
}



export const getEmployees = async ({ limit, offset, byName, totalEmployees }) => {
  try {
    let endpoint = `${consts.BASE_PATH_API}api/funcionarios?status=true&employeesByUser=true&filter[sort]=a-z`;
    if (totalEmployees <= 1750) {
      endpoint = `${consts.BASE_PATH_API}funcionarios/getEmployeesEnrollment?devices_page=true`;
    }

    const url = byName?.trim()
      ? `${endpoint}&byName=${byName}&byEnrollment=${byName}`
      : `${endpoint}&limit=${limit}&offset=${offset}`;

    const response = await api.get(url);
    if (response.error) {
      throw new Error('Não foi possível carregar os funcionários');
    }
    return {
      data: response.data
    };
  } catch (error) {
    throw new Error(`Erro ao carregar os funcionários: ${error.message}`);
  }
}

export const getCurrentCompanyTotalActiveEmployees = async () => {
  try {
    const response = await api.get(`${consts.BASE_PATH_API}api/empresas/getCurrentCompanyTotalActiveEmployees`);
    return response.data;
  } catch (error) {
    throw new Error(`Erro ao carregar o total de funcionários ativos: ${error.message}`);
  }
}
export const getLocationsAndCnpj = async () => {
  try {
    const response = await api.get(`${consts.BASE_PATH_API}api/empresas/getDevicesPermissions`);
    if (response.error) {
      throw new Error('Não foi possível carregar os funcionários');
    }

    
    // Caso o CNPJ seja um objeto, transforma em array
    let cnpjs = response.data.cnpj;
    if (typeof cnpjs === 'object' && !Array.isArray(cnpjs)) {
      cnpjs = Object.values(cnpjs);
    }

    // Formata os CNPJs com razão social
    const formattedCnpjs = cnpjs.map(cnpjItem => {
      // Se for string, retorna como objeto
      if (typeof cnpjItem === 'string') {
        return {
          cnpj: cnpjItem,
          razao_social: 'Razão social não cadastrada'
        };
      }
      
      // Se for objeto, garante que tenha razão social
      return {
        cnpj: cnpjItem.cnpj || cnpjItem,
        razao_social: cnpjItem.razao_social?.trim() || 'Razão social não cadastrada'
      };
    });

    // Caso as localizações sejam um objeto, transforma em array
    let locations = response.data.locations;
    if (typeof locations === 'object' && !Array.isArray(locations)) {
      locations = Object.values(locations);
    }

    return {
      locations,
      cnpjs: formattedCnpjs,
      company: response.data.company
    };
  } catch (error) {
    throw new Error(`Erro ao carregar os funcionários: ${error.message}`);
  }
}

export const getDevice = async ({ identity, existingEmployees = [] }) => {
  try {

    const url = `${consts.BASE_PATH_API}batidaonline/getRegistration?identity=${encodeURIComponent(identity)}`;

    // Add a small delay before fetching
    await new Promise(resolve => setTimeout(resolve, 500));

    // Make sure we're not sending any body with the GET request
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    }).then(res => res.json());

    // Check if response exists and has data
    if (!response) {
      console.error('No response received from API');
      throw new Error('Não foi possível carregar o dispositivo - Sem resposta do servidor');
    }

    // If the response has a data property, use that
    const responseData = response.data || response;

    // Transform the response data
    const deviceData = {
      ...responseData,
      name: responseData.name ? responseData.name.replace(/&nbsp;/g, "").replace(/&nbsp/g, "") : "",
      active: Boolean(responseData.active),
      deviceType: responseData.device_type || '',
      timezone: responseData.timezone || '',
      cnpj: responseData.cnpj || '',
      employees: responseData.employees || [],
      locations: Array.isArray(responseData.locations) ? responseData.locations : [],
      ips: responseData.range_ip ? responseData.range_ip.split(',').map(ip => ip.trim()) : [],
      collaboratorsType: responseData.optionEmployeesFilter === '1' ? 'by_employee' : 'by_location',
    };

    // If validation is really needed and we have existing employee data
    if (deviceData.employees.length > 0 && existingEmployees.length > 0) {
      deviceData.employees = deviceData.employees.filter(empId =>
        existingEmployees.some(emp => String(emp.dados.matricula) === String(empId))
      );
    }

    return deviceData;

  } catch (error) {
    console.error('Error fetching device:', error);
    console.error('Error details:', {
      message: error.message,
      stack: error.stack,
      response: error.response
    });
    throw new Error(`Erro ao carregar dispositivo: ${error.message}`);
  }
}

